import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "buttonClose", "container"];

  appear(){
    this.containerTarget.classList.remove("hidden");
    this.buttonCloseTarget.classList.remove("hidden");
    this.buttonTarget.classList.add("hidden");
  }

  disAppear() {
    this.containerTarget.classList.add("hidden");
    this.buttonCloseTarget.classList.add("hidden");
    this.buttonTarget.classList.remove("hidden");
  }
}
